// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const contentWrapper = "Logout__contentWrapper__DeIQ2";
export const emailSection = "Logout__emailSection__pETUh font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const share = "Logout__share__0OkLh";
export const shareButtonWrapper = "Logout__shareButtonWrapper__BRV75";
export const shareButtons = "Logout__shareButtons__DPr7D";
export const shareText = "Logout__shareText__VSjMd font-faces__sansRegular__c8KXl font-faces__sans__uCf65";